import { render } from "./TermEditHeader.vue?vue&type=template&id=3cfe89e0&scoped=true&ts=true"
import script from "./TermEditHeader.vue?vue&type=script&lang=ts"
export * from "./TermEditHeader.vue?vue&type=script&lang=ts"

import "./TermEditHeader.vue?vue&type=style&index=0&id=3cfe89e0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cfe89e0"]])

export default __exports__